'use strict';

var sleeknote = sleeknote || {};

sleeknote.tabbed = sleeknote.tabbed || function () {

    function init() {
        tabbedContent();
    }

    function tabbedContent(){

        $(document).ready(function(){

            if ( $('.tabbed-js').length ){

                $('.tabbed-js').each(function(){

                    var thisTabbed = $(this);

                    thisTabbed.find('.tabbed-nav ul li').click(function(e){

                        thisTabbed.find('.active').removeClass('active');
                        var target = $(this).data('target');
                        thisTabbed.find(target).addClass('active');

                        if(thisTabbed.find(target).hasClass('video')){

                            thisTabbed.find(target).find('.w-big-play-button').trigger('click');

                        }

                        $(this).addClass('active');

                    });
                    thisTabbed.find('.tabbed-select-nav').change(function(){
                        thisTabbed.find('.active').removeClass('active');
                        var target = $(this).val();
                        thisTabbed.find(target).addClass('active');
                    });
                        

                });

            }


        });


    }


    return {
        init:init
    };


}();